import React from "react";
import PropTypes from "prop-types";
import {Switch} from "./styles";

/**
 * Toggle switch reutilizável do Group Manager (mesma aparência em Operator Access
 * e Group Settings). Encapsula um checkbox acessível — o aria-label vai no input.
 */
const Toggle = ({checked, onChange, disabled, "aria-label": ariaLabel}) => (
    <Switch>
        <input
            type="checkbox"
            checked={!!checked}
            onChange={onChange}
            disabled={disabled}
            aria-label={ariaLabel}
        />
        <span/>
    </Switch>
);

Toggle.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    "aria-label": PropTypes.string,
};

export default Toggle;
